import { getAttendanceEmployeeList } from '../../Thunks/HeyTraderThunks';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SiteEmployeeType } from '../../Types/HeyTraderTypes/Attendances/SiteEmployeeType';



interface AttendanceEmployeeSliceState {
    loader: boolean; // for refres pages and inital loadings
    attendanceEmployeeList: SiteEmployeeType[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : AttendanceEmployeeSliceState = {
    loader: false,
    attendanceEmployeeList: [],
    errorDisplay: '',

}

// set state valu for api response
const attendanceEmployeeSlice = createSlice ({
    name: 'attendanceEmployees',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAttendanceEmployeeList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAttendanceEmployeeList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAttendanceEmployeeList.fulfilled, (state, action: PayloadAction<SiteEmployeeType[]>) => {
                    state.loader = false;
                    state.attendanceEmployeeList = action.payload;
                  })
    }
})

export const {} = attendanceEmployeeSlice.actions
export default attendanceEmployeeSlice.reducer
